export default __webpack_public_path__ + "img/2cd8c65bbbb015306601f26d94c418a9.svg";